import { faker } from '@faker-js/faker';
import {
  cleanup,
  fireEvent,
  render,
  screen,
  waitFor,
} from '@testing-library/react';
import * as React from 'react';
import { expect } from 'vitest';

import en from '../../translations/en/bulkPauseUnpause.json';
import BulkPauseUnpauseContainer from './index';
import redux from './redux';

function TestComponent() {
  return (
    <BulkPauseUnpauseContainer
      customer_group_id={faker.number.int({ max: 1000, min: 10 })}
      customer_id={faker.number.int({ max: 1000, min: 10 })}
      userTimezone="America/Toronto"
    />
  );
}

describe('bulk pause unpause container', () => {
  afterEach(() => {
    cleanup();
  });

  test('should render the bulk pause unpause container', async () => {
    render(<TestComponent />);
    const button = await screen.findByText(en['action.button-text']);
    expect(button).toBeDefined();
    dispatchEvent(
      new CustomEvent('MachineSelectionStatusChanged', {
        detail: [{ id: faker.number.int(), name: faker.string.alphanumeric() }],
      }),
    );
    const spy = vi.spyOn(redux.modal, 'open');
    await waitFor(() => expect(button).not.toBeDisabled());
    fireEvent.click(button);
    expect(spy).toHaveBeenCalledTimes(1);
  });
});
